module.exports = __webpack_public_path__ + "img/icon_point2-2.91448061.svg";